import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPieChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPieChart3"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M12 3V12L18.5 18.5" stroke="currentColor"/><Path d="M12 12.0001L20.5 8.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPieChart3;
